module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Rain5-d88007dc3a6e8ee4005fc829a13d03cf.svg";